var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsUpActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.178,
    height: 38.189,
    viewBox: "0 0 38.178 38.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332",
    transform: "translate(-84 -930.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up",
    d: "M11.2,17.668,17.082,4.241A3.514,3.514,0,0,1,21.86,2.372c2.762,1.479,2.208,2.865,2.208,11.568H34.493a3.712,3.712,0,0,1,3.635,4.295L35.582,35.011a3.694,3.694,0,0,1-3.635,3.161H11.2m0-20.5v20.5m0-20.5H5.678A3.7,3.7,0,0,0,2,21.4V34.444a3.7,3.7,0,0,0,3.678,3.728H11.2",
    transform: "translate(83 929.594)",
    fill: "#f4bcb9",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    d: "M2,0H8A0,0,0,0,1,8,0V19a0,0,0,0,1,0,0H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(86 948)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpActive);
export default __webpack_public_path__ + "static/media/thumbs-up-active.39fdb304f0b97ed85df3328414318a18.svg";
export { ForwardRef as ReactComponent };